module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_SalaoFestas332.23e40a7c.jpg";